import React, { Component, Fragment } from 'react';
import { Card, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { CKEditor } from '@ckeditor/ckeditor5-react';
//import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ProceduresPDF from './ProceduresPDF';
import Spinner from 'react-bootstrap/Spinner';

class ProcedureForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            motivo_consulta: this.props.history.motivo_consulta != null && this.props.history.motivo_consulta != undefined ? this.props.history.motivo_consulta : null,
            resultados: "",
            procedimiento: this.props.procedimiento != null && this.props.history.procedimiento != undefined ? this.props.history.procedimiento : null,
            observaciones: this.props.history.observaciones != null && this.props.history.observaciones != undefined ? this.props.history.observaciones : null,
            interpretacion: this.props.history.interpretacion != null && this.props.history.interpretacion != undefined ? this.props.history.interpretacion : null,
            id_informe: "",
            parametros: "",
            age: '',
            plans: [],
            planName: '',
            idPlan: '',
            urlLogo: '',
            disableInput: false,
            exist: false,
            onUpdate: false,
            loading: true,

        }
    }

    componentDidMount() {
        this.getDataHistory();
    }

    getDataHistory = () => {

        if (this.props.dataHistory.length > 0) {

            const data = this.props.dataHistory;

            for (let i = 0; i < data.length; i++) {
                if (data[i].tipo_informe === 4) {
                    //console.log(data[i]);
                    this.setState({
                        loading: false,
                        id_informe: data[i].id_hist_informes,
                        motivo_consulta: data[i].motivo_consulta,
                        procedimiento: data[i].procedimiento,
                        interpretacion: data[i].interpretacion,
                        observaciones: data[i].observacion,
                        resultados: data[i].resultados,
                        parametros: data[i].parametro_estimulacion,
                        exist: true,
                        disableInput: true
                    });

                } else if ((i + 1) === data.length) {
                    this.setState({ loading: false });
                }
            }
        } else {
            this.setState({ loading: false });
        }
    }

    makePdf = async () => {

        const dataPdf = {
            names: this.props.data.nombres,
            documentNumber: this.props.data.num_documento,
            edad: this.state.age,
            motivo_consulta: this.state.motivo_consulta,
            resultados: this.state.resultados,
            procedimiento: this.state.procedimiento,
            interpretacion: this.state.interpretacion,
            observaciones: this.state.observaciones,
            parametros: this.state.parametros,
            age: this.props.age, //this.state.age,
            plan: this.props.planName, //this.state.planName,
            id_historia: this.props.data.id_historia,
            telephone: this.props.data.telephone !== null ? this.props.data.telephone : '',
            address: this.props.data.adress.direccion !== null ? this.props.data.adress.direccion: '',
            remitente: this.props.data.remitente,
            fecha: this.props.data.fecha,
            hora: this.props.data.fecha_ingreso_completa,
            ocupation: this.props.data.ocupacion !== null ? this.props.data.ocupacion :'',
        }

        ProceduresPDF(dataPdf);
    }

    saveData = async () => {

        const dataToSend = {
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision,
            motivo_consulta: this.state.motivo_consulta,
            procedimiento: this.state.procedimiento,
            parametro_estimulacion: this.state.parametros,
            resultados: this.state.resultados,            
            interpretacion: this.state.interpretacion,
            observacion: this.state.observaciones,           
            recomendaciones: '',
            conclusion: "",
            nota: "",
            fecha: this.props.data.fecha,
            id_servicio: null,
            tipo_informe: 4,
            antecedentes_paciente: null,
            lengua_payne: null,
            observacion2: null,
            mioescanografia: null
        }

        console.log(dataToSend);

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.makePdf().then(() => {
                    this.setState({ exist: true, disableInput: true });
                });
            })
            .catch((error) => {
                console.error('Error:', error);

            });
    }

    updateData = () => {

        const dataToSend = {
            id_hist_informes: this.state.id_informe,
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision,
            motivo_consulta: this.state.motivo_consulta,
            procedimiento: this.state.procedimiento,
            parametro_estimulacion: this.state.parametros,
            resultados: this.state.resultados,           
            interpretacion: this.state.interpretacion,
            observacion: this.state.observaciones,
            recomendaciones: '',
            conclusion: "",
            nota: "",
            fecha: this.props.data.fecha,
            id_servicio: null,
            tipo_informe: 4,
            antecedentes_paciente: null,
            lengua_payne: null,
            observacion2: null,
            mioescanografia: null

        }

        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.makePdf().then(() => {
                    //window.location.reload();
                    this.setState({ disableInput: true, exist: true, onUpdate: false });
                });

            })
            .catch((error) => {
                console.error('Error:', error);
                //reject(error)
            });
    }



    render() {

        return (
            <Card>
                {this.state.loading ?
                    <div className="text-center">
                        <Spinner animation="border" variant="success" />
                    </div>
                    :
                    <Fragment>
                        <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
                            <div className="card__title">
                                <h5 className="bold-text">Resumen De Historia Clinica </h5>
                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Antecedentes/ Motivo de Consulta</span>
                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-motivo-consulta"
                                            value={this.state.motivo_consulta}
                                            onChange={(e) => { this.setState({ motivo_consulta: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Procedimeinto </span>
                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-procedimiento"
                                            value={this.state.procedimiento}
                                            onChange={(e) => { this.setState({ procedimiento: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                            <span style={{ marginTop: 15, marginLeft: 10 }} className="form__form-group-label">Parametros de Estimulación para el Registro</span>
                            <div style={{ margin: 10 }}>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={this.state.exist ? this.state.parametros : this.props.history.parametros}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        this.setState({ parametros: data });
                                        //this.props.handlerHistoryInfo('resultados', data);
                                        //console.log(data);
                                    }}
                                />
                            </div>

                            <span style={{ marginTop: 15, marginLeft: 10 }} className="form__form-group-label">Resultados</span>
                            <div style={{ margin: 10 }}>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={this.state.exist ? this.state.resultados : this.props.history.resultados}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        this.setState({ resultados: data });
                                        //this.props.handlerHistoryInfo('resultados', data);
                                       // console.log(data);
                                    }}
                                />
                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label"> Interpretacion </span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-interpretacion"
                                            value={this.state.interpretacion}
                                            onChange={(e) => { this.setState({ interpretacion: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label"> Observacion</span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-observacion"
                                            defaultValue={this.state.observaciones}
                                            onChange={(e) => { this.setState({ observaciones: e.target.value }) }}
                                            disabled={this.state.disableInput}>
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <Button
                                    style={{ marginRight: 12, marginTop: 20 }}
                                    size="sm"
                                    color="primary"
                                    onClick={() => {
                                        if (this.state.exist)
                                            this.makePdf();
                                        else
                                            this.saveData();
                                    }}
                                >
                                    {this.state.exist ? " Generar Reporte" : " Guardar y Generar Reporte"}
                                </Button>

                                {this.state.exist ?
                                    <Button
                                        style={{ marginTop: 20 }}
                                        size="sm"
                                        color="primary"
                                        onClick={() => {

                                            if (this.state.onUpdate)
                                                this.updateData();
                                            else
                                                this.setState({ disableInput: false, onUpdate: true });
                                        }}
                                    >
                                        {this.state.onUpdate ? "Actualizar" : " Habilitar Actualizacion"}
                                    </Button>
                                    : null}
                            </div>
                        </div>
                    </Fragment>}
            </Card>
        );
    }
}

export default reduxForm({
    form: 'report_ardila_form', // a unique identifier for this form
})(withTranslation('common')(ProcedureForm));
